"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDateRange = void 0;
var React = require("react");
require("./FieldDateRange.css");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
var GridCol_1 = require("player-layout-controls/controls/GridCol");
var Text_1 = require("player-common-controls/controls/Text/Text");
var date_picker_1 = require("@csod/date-picker");
var FieldDateRange = (function (_super) {
    __extends(FieldDateRange, _super);
    function FieldDateRange(props) {
        var _this = _super.call(this, props) || this;
        _this._idTag1 = props.idTag + "_1",
            _this._idTag2 = props.idTag + "_2";
        return _this;
    }
    FieldDateRange.prototype.render = function () {
        var _a = this.props, startDateTitle = _a.startDateTitle, endDateTitle = _a.endDateTitle, isRequired = _a.isRequired, value1 = _a.value1, value2 = _a.value2, errorMessage = _a.errorMessage, startDateErrorMessage = _a.startDateErrorMessage, endDateErrorMessage = _a.endDateErrorMessage, displayFullDate = _a.displayFullDate, onChange = _a.onChange, onRef = _a.onRef, idTag = _a.idTag, shouldClearIfNotValid = _a.shouldClearIfNotValid;
        var classes = ['p-field-date-range'];
        (startDateErrorMessage || endDateErrorMessage || errorMessage) && classes.push('is-invalid');
        return (React.createElement("div", { className: classes.join(' ') },
            React.createElement(GridLayout_1.GridLayout, { gutterHorizontal: "Small" },
                React.createElement(GridCol_1.GridCol, { width: "Fill" },
                    React.createElement(date_picker_1.default, { label: startDateTitle, isRequired: isRequired, format: displayFullDate ? "Short" : "MonthOnlyShort", value: value1, tag: this._idTag1, id: this._idTag1, showLabel: true, onChange: onChange, onRef: onRef, ariaLabeledBy: idTag, shouldClearIfNotValid: shouldClearIfNotValid, errorMessage: startDateErrorMessage || errorMessage, showMonthYearPicker: true, isMonthPicker: !displayFullDate })),
                React.createElement(GridCol_1.GridCol, { width: "Auto" },
                    React.createElement("div", { className: "date-divider" },
                        React.createElement(Text_1.Text, { text: "-" }))),
                React.createElement(GridCol_1.GridCol, { width: "Fill" },
                    React.createElement(date_picker_1.default, { label: endDateTitle, format: displayFullDate ? "Short" : "MonthOnlyShort", value: value2, tag: this._idTag2, id: this._idTag2, showLabel: true, onChange: onChange, ariaLabeledBy: idTag, shouldClearIfNotValid: shouldClearIfNotValid, errorMessage: endDateErrorMessage || errorMessage, showMonthYearPicker: true, isMonthPicker: !displayFullDate })))));
    };
    FieldDateRange.defaultProps = {
        startDateTitle: '',
        endDateTitle: '',
        isRequired: false,
        value1: new Date,
        value2: new Date,
        idTag: '',
        shouldClearIfNotValid: false,
        errorMessage: '',
        startDateErrorMessage: '',
        endDateErrorMessage: '',
        displayFullDate: true,
        onChange: void (0)
    };
    return FieldDateRange;
}(React.Component));
exports.FieldDateRange = FieldDateRange;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["FieldDateRange"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/FieldDateRange/FieldDateRange.js
// module id = 380
// module chunks = 0 1